import { defaultConfigs, SharedConfigurations } from '@pulse/common';

export const sharedDefaultConfigs: SharedConfigurations = {
    ...defaultConfigs,
    transportTimeout: 60000,
    transportRetries: Number.POSITIVE_INFINITY,
    transportRetryBackoffMS: 100,
    transportRetryBackoffMaxMS: 30000,
    pulseClientType: 'browser',
    tabManagerStorageType: 'tab',
    sessionStorageType: 'persistent',
    initialDocURL: '',
    experimentStorageKey: 'experiments',
    keySessionID: 'sid',
    keyDeviceId: 'did',
    trafficSourceDetectorStorageType: 'persistent',
    cacheStorageType: 'persistent',
    eventEnrichment: true,
    autopilotTracking: {
        enabled: false,
    },
    environment: null,
    pulseMini: false,
};
